import React from 'react';
import Message from '../../../components/common/Message';
import {Icon, svgs} from 'epic-diesel-common/src';
import PayoutReportListItem from './PayoutReportListItem';
import {PayoutReportState} from '../../../reducers/payout';

//@ts-ignore
import styles from './PayoutReport.pcss';

export interface PayoutReportList {
    getPayoutReportDetail: (data) => void;
    reportState: PayoutReportState;
}

const PayoutReportList: React.FC<PayoutReportList> = ({getPayoutReportDetail, reportState}) => {
    if (reportState.loadingList && reportState.isLimited) {
        return (
            <div className={styles.loader}>
                <Icon className={styles.icon} icon={svgs.LOADING} fontSize="large" />
            </div>
        );
    }

    const reportList = reportState.reportList;
    let listValues;

    if (!reportList || reportList.length === 0) {
        listValues = (
            <div className={styles.noPayment}>
                <p>
                    <Message code="label.affiliate.form.payoutReport.noPayments" />
                </p>
            </div>
        );
    } else {
        listValues = reportList.map(report => (
            <PayoutReportListItem
                key={report.paymentId}
                item={report}
                loadingDetail={reportState.loadingDetail}
                getPayoutReportDetail={getPayoutReportDetail}
            />
        ));
    }

    return (
        <div className={styles.payoutItem}>
            <div className={styles.payoutItemTitle}>
                <p>
                    <Message code="label.affiliate.form.payoutReport.status.v2" />
                </p>
                <p>
                    <Message code="label.affiliate.form.payoutReport.notes.v2" />
                </p>
                <p>
                    <Message code="label.affiliate.form.payoutReport.date.v2" />
                </p>
                <p>
                    <Message code="label.affiliate.form.payoutReport.amount.v2" />
                </p>
                <div className={styles.action} />
            </div>
            {listValues}
        </div>
    );
};

export default PayoutReportList;
